module.exports = {
  formatCurrency(value) {
    return parseFloat(value).toFixed(2);
  }
};
